<template>
  <div class="products-section ">
    <slot></slot>
    <transition name="fade">
      <div v-if="initialLoad || (loading && products.length == 0)" class="products-grid">
        <product-skeleton v-for="n in 6" :key="n" />
      </div>
    </transition>

    <transition name="fade">
      <div v-if="!loading && products.length > 0" class="products-grid">
        <product-card
          v-for="(product, index) in displayedProducts"
          :key="index"
          :product="product"
          :category="product.category"
        ></product-card>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_SHOP_LOADING, GET_FILTERED_PRODUCTS_BY_CATEGORY_CASE, GET_FILTERED_PRODUCTS_BY_CATEGORY } from '../../store/shop/types'
import ProductSkeleton from './ProductSkeleton'

export default {
  props: ['type'],
  components: {
    ProductSkeleton,
  },
  data() {
    return {
      initialLoad: true,
    };
  },
  computed: {
    ...mapGetters({
      loading: GET_SHOP_LOADING,
      products: GET_FILTERED_PRODUCTS_BY_CATEGORY,
      productsCase: GET_FILTERED_PRODUCTS_BY_CATEGORY_CASE,
    }),
    displayedProducts() {
      return this.type === 'seeds'
        ? this.productsCase
        : this.products
    },
  },
  watch: {
    loading(val) {
      if (!val && this.initialLoad) {
        this.initialLoad = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";

.products-section {
  transition: all;
  margin-top: 50px;
  min-height: 60vh;
  display: flex;
  justify-content: center;

  @media(max-width: $breakpoint-landing-tablet){
    justify-content: center;
  }

  @media (min-width: 992px) {
    min-width: 630px;
  }
  @media (min-width: 1024px) {
    min-width: 860px;
  }
  @media (min-width: 1240px) {
    min-width: 1150px;
  }
  @media (min-width: 1532px) {
    min-width: 1440px;
  }

  .products-grid {
    display: grid;
    gap: 10px;
    justify-content: center;
    max-width: 1350px;
    grid-template-rows: min-content;
    @media (min-width: 908px) {
       grid-template-columns: repeat(3, minmax(160px, 1fr));
    }
    @media (max-width: 908px) {
       grid-template-columns: repeat(2, minmax(160px, 1fr));
    }
    @media (min-width: 992px) {
      grid-template-columns: repeat(2, minmax(160px, 1fr));
    }

    @media (min-width: 1240px) {
      grid-template-columns: repeat(3, minmax(160px, 1fr));
    }

    @media (min-width: 1532px) {
      grid-template-columns: repeat(4, minmax(160px, 1fr));
    }
  }

  .best-card {
    margin: 0;
    @media (min-width: 640px) {
      margin: .5rem;
    }
  }

  .fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

}
</style>

